import * as React from 'react';
import { Image } from '@cian/ui-kit';
import { ISlide } from '@cian/frontend-fullscreen-carousel-component';

import { IImages } from '../../../types/newbuildingsCompare';
import * as style from './style.css';

export function prepareSlides(mediaData: IImages[]): ISlide[] {
  return mediaData.map(media => ({
    node: (
      <div className={style['slide']}>
        <Image src={media.fullUrl} height="auto" loading="lazy" objectFit="contain" />
      </div>
    ),
  }));
}
